import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor() { }

  file: File;
  image: string;
  dirty: boolean = false;

}